export enum ContractStatus {
  Trial = 'trial',
  Active = 'active',
  Expired = 'expired'
}
